import { Node_Type } from "./../../ricos-types";
import Divider from "./divider";
const nodeViewRenderers = {
  [Node_Type.DIVIDER]: Divider
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
